var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"mask"},[_c('div',{staticClass:"popup",style:({
                backgroundImage: ("url(" + _vm.mainPic + ")")
            })}),_c('button',{staticClass:"btn",on:{"click":_vm.next}})])])}
var staticRenderFns = []

export { render, staticRenderFns }